export default "__VITE_ASSET__D1izrrqY__"